import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Row, Col, Card, CardBody, Form, Spinner } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import { postRequestForm } from "../../components/Common/Utils.js";

export default function UpdateSize() {
  const [sizeData, setSizeData] = useState({
    homeBlockSizeId:"",
    type: "",
    ratio: "",
  });
  const [loading, setLoading] = useState(false);
  const [startLoader, setStartLoader] = useState(false);
  let history = useHistory();
  const { homeBlockSizeId } = useParams();

  useEffect(() => {
    const fetchSizeData = async () => {
      setLoading(true);
      // Assuming there's an API to fetch the size data by ID
      const response = await postRequestForm(`home-block/size-list`,{homeBlockSizeId});
      setLoading(false);
      if (response?.status) {
        setSizeData({
          type: response.data.type || "",
          ratio: response.data.ratio || "",
        });
      } else {
        toast.error("Failed to load size data.");
      }
    };

    fetchSizeData();
  }, [homeBlockSizeId]);

  const validateRatio = (ratio) => {
    const regex = /^[0-9]+(\.[0-9]+)?$/; // Validates a positive number with optional decimal
    return regex.test(ratio);
  };

  const handleUpdateSize = async (e) => {
    e.preventDefault();

    if (!sizeData.type || !sizeData.ratio) {
      toast.error("All fields are required.");
      return;
    }

    if (!validateRatio(sizeData.ratio)) {
      toast.error("Ratio must be a valid number.");
      return;
    }

    setStartLoader(true);
    setLoading(true);

    const formData = new FormData();
    formData.append("homeBlockSizeId", homeBlockSizeId);
    formData.append("type", sizeData.type);
    formData.append("ratio", sizeData.ratio);

    const response = await postRequestForm(`home-block/update-size`, formData);
    setLoading(false);
    setStartLoader(false);

    if (response?.status) {
      toast.success("Home Block Size Updated!");
      setTimeout(() => {
        history.goBack();
      }, 1000);
    } else {
      toast.error(response?.message || "Error occurred while updating size.");
    }
  };

  const updateValue = (field, value) => {
    setSizeData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Row>
        <Col className="10">
          <div className="page-title-box">
            <h4>Home Block Size Management</h4>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">Size</li>:{" "}
              <li className="breadcrumb-item">Update Size</li>
            </ol>
          </div>
        </Col>
        <div class="col-md-2 text-end">
          <button
            type="button"
            onClick={() => history.goBack()}
            className="btn btn-primary  btn-lg"
          >
            <i class="fas fa-chevron-left"></i> Back
          </button>
        </div>
      </Row>

      <Row>
        <Col lg={12}>
          <Card>
            {loading ? (
              <CardBody style={{ height: "100px" }}>
                <Spinner
                  color="info"
                  style={{
                    height: "4rem",
                    width: "4rem",
                    position: "absolute",
                    left: "50%",
                  }}
                >
                  Loading...
                </Spinner>
              </CardBody>
            ) : (
              <CardBody>
                <h4 className="card-title">Update Size</h4>

                <Form onSubmit={handleUpdateSize}>
                  <Row>
                    <Col lg={12} className="ms-lg-auto">
                      <div className="mt-5 mt-lg-4">
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">Type</label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={(e) => updateValue("type", e.target.value)}
                              value={sizeData.type}
                              name="type"
                              className="form-control"
                              required
                            />
                          </div>
                        </div>

                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">Ratio</label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={(e) => updateValue("ratio", e.target.value)}
                              value={sizeData.ratio}
                              name="ratio"
                              className="form-control"
                              required
                            />
                          </div>
                        </div>

                        <div className="mt-5 mt-lg-4">
                          <div className="row justify-content-end">
                            <div className="col-sm-9">
                              <div>
                                <button type="submit" className="btn btn-primary w-md">
                                  Submit
                                </button>
                            
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            )}
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
}
